import client from './client';

export const startImageSync = async () => {
  return await client.post('/api/sync/images');
};

export const getImageSyncStatus = async () => {
  return await client.get('/api/sync/status');
};

/**
 * Trigger a background job that scans the S3 bucket and
 * upserts / deletes records in pms_item_image_check accordingly.
 */
export const startS3Scan = async () => {
  return await client.post('/api/sync/scan-s3');
};

/**
 * Poll the current status of the running (or last completed) S3 scan job.
 */
export const getS3ScanStatus = async () => {
  return await client.get('/api/sync/scan-s3/status');
};
